import React, { useEffect } from "react";
import moment from "moment";
import { useGetPublicationCalendarHistoryQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const PublicationsHistory = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["report_type_key"]); // No filters required
    }, []);

    // const getInitialDateRange = () => {
    //     const endDate = moment().format('DD-MM-YYYY');
    //     const startDate = moment().subtract(21, 'months').format('DD-MM-YYYY');

    //     return { startDate, endDate };
    // };

    // const initialDateRange = getInitialDateRange();

    const checkIfKeyReport = (row) => {
        let styles = {};
        if (row.report_type === "Key Reports Total") {
            styles = {
                color: "#ED1C24",
                fontWeight: "bold",
            };
        }
        return styles;
    };
    return (
        <div className="overflow-auto">
            <PaginatedDataTable
                queryHook={useGetPublicationCalendarHistoryQuery}
                initialDateRange={dateRange}
                totalText="All Report Total"
                firstColumnWidth="100px"
                isColumnSticky={true}
                appliedFilters={appliedFilters}
                stickyColumnsCount={1}
                customCellColor={(header, row) => checkIfKeyReport(row)}
            />
        </div>
    );
};

export default PublicationsHistory;
